import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage, HrefPill } from '../../components';

function SignaturePrograms({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  const ctas = data.ctas || [];
  const updateCta = (i, patch) => {
    const next = ctas.map((c, idx) => (idx === i ? { ...c, ...patch } : c));
    update({ ctas: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
          <div className="mt-8 space-y-4">
            {items.map((p, i) => (
              <div key={i} className="p-5 rounded-2xl bg-olive-light border-l-4 border-olive">
                <EditableText value={p.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-semibold text-olive-deep text-lg" />
                <EditableText value={p.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="mt-1 text-ink/70 text-sm leading-relaxed" />
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            {ctas.map((c, i) => {
              const isPrimary = (c.variant || 'primary') === 'primary';
              return (
                <div key={i} className="inline-flex flex-col">
                  <Link to={c.href || '#'} className={isPrimary ? 'btn-primary' : 'btn-ghost'}>
                    <EditableText value={c.label} onChange={(t) => updateCta(i, { label: t })} as="span" />
                    {isPrimary && <ArrowRight size={16} />}
                  </Link>
                  <HrefPill value={c.href} onChange={(h) => updateCta(i, { href: h })} />
                </div>
              );
            })}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <EditableImage
            src={data.image?.src}
            alt={data.image?.alt || 'Signature'}
            onChange={(src, alt) => update({ image: { src, alt } })}
            className="rounded-3xl shadow-soft h-[520px] w-full object-cover"
          />
        </Reveal>
      </div>
    </section>
  );
}

export default SignaturePrograms;
